<template>
    <div>
        <div v-if="warningMessageIsDisplayed" class="alert alert-warning alert-dismissible fade show" role="alert">
            <i class="fa fa-info" aria-hidden="true"></i> {{ warningMessage }}
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <record-form :id="id"
                     :form-fields="formFields"
                     :record-type="recordType">
            <template slot="submit-button-label">
                <slot name="upload-file-button-label">
                    <i class="fa fa-upload" aria-hidden="true"></i> Upload
                </slot>
            </template>

            <template slot="cancel-button">&#8203;</template>
        </record-form>

        <loading-indicator v-show="isUploading" 
                           :width="50" 
                           :height="50">
        </loading-indicator>

        <confirmation-dialog v-if="confirmOnUpload"
                             :id="id"
                             :title="confirmTitle"
                             :message="confirmMessage">
        </confirmation-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            formFields: { type: Object, required: true },
            recordType: { type: String, required: true },
            formActionUri: { type: String, required: true },
            redirectAfterSubmitUri: { type: String, required: true },
            confirmOnUpload: { type: Boolean, required: false, default: false },
            confirmTitle: { type: String, required: false, default: "Confirm" },
            warningMessage: { type: String, required: false, default: "" },
            confirmMessage: { type: String, required: false, default: "Are you sure you want to upload?" }
        },

        data() {
            return {
                id: this._uid,
                isUploading: false,
                warningMessageIsDisplayed: false
            }
        },

        created() {
            EventDispatcher.listen('recordFormSubmitted' + this.id, (form) => {
                if(this.confirmOnUpload) {
                    EventDispatcher.fire('showConfirmationDialog' + this.id, {
                        onConfirmCallback: this.onSubmit.bind(null, form)
                    });
                } else {
                    this.onSubmit(form);
                }
            });

            EventDispatcher.listen('multiFilesChanged', (fileList) => {
                // Make an array out of the FileList Object; then, if any of the selected files is a TIFF file, display the warning message; hide it otherwise.
                Array.from(fileList).every((file) => file.type !== 'image/tiff') ? this.toggleWarningMessage(false) : this.toggleWarningMessage(true)
            });
        },

        methods: {
            redirectToPage() {
                // reload current tab after attaching record (requires page reload)
                if(this.redirectAfterSubmitUri === window.location.pathname) {
                    window.location = this.redirectAfterSubmitUri + window.location.hash;
                    window.location.reload();
                } else { // redirect to redirectAfterSubmitUri if it is not the current page
                    window.location = this.redirectAfterSubmitUri;
                }
            },

            onSubmit(form) {
                this.isUploading = true;
                form.post(this.formActionUri).then(response => {
                    this.isUploading = false;
                    this.redirectToPage();
                }).catch(error => {
                    // create custom error message when server exception occurs
                    if(error.data && error.data.exception) {
                        if(error.status == 413) {
                            // get the name of the file input form field
                            let fieldName = Object.keys(this.formFields)[0];

                            // create a custom error message on the file input form field
                            var errors = [];
                            errors[fieldName] = ["The uploaded images exceed the server's maximum allowed upload size."];

                            // assign the custom error message to the form so it can dynamically render the error message
                            form.onFail(errors);
                        }
                    }
                    this.isUploading = false;
                });
            },

            toggleWarningMessage(displayStatus) {
                this.warningMessageIsDisplayed = displayStatus
            }
        }
    }
</script>